import React from 'react'
import { CgProfile } from "react-icons/cg";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { FaRegThumbsUp } from "react-icons/fa6";
import { MdCalendarMonth } from "react-icons/md";

const Card2 = (props) => {
    const data=props.data
  return (
    <div className='w-full'>


        <div className='flex lg:gap-x-5 w-11/12 mx-auto justify-around  p-4'>

            <CgProfile className='w-1/5 lg:w-1/4 h-[100px] sm:h-[150px] lg:h-[250px] place-self-center hidden lg:inline-block' />

            <div className='w-1/2 lg:w-2/5 flex flex-col gap-y-1 items-start'>
                <div className='text-xl text-blue-900 font-semibold'>Dr. {data.firstName} {data.lastName} </div>
                <div className='text-sm '>{data.Category} </div>
                <div className='text-sm'>{data.Experience} Years Experience overall</div>
                <div className='flex flex-col items-start md:flex-row md:items-center text-sm gap-x-2'>
                    <div className='font-bold '>{data.Address}</div>
                    <div></div>
                    <div>{data.Clinic} </div>
                </div>
                <div className='flex items-center gap-x-1 text-sm'>
                    <MdOutlineCurrencyRupee/>
                    <div> {data.Fee} Consultation fee at clinic</div>
                </div>

                <div className='w-full h-[1px] bg-black mt-2'/>

                <div className='flex items-center gap-x-4 mt-6'>
                    <div className='flex items-center gap-x-1 px-3 py-2 bg-green-400 text-white font-bold rounded-md'>
                        <FaRegThumbsUp/>
                        <div>85%</div>
                    </div>

                    <div className='text-sm underline'>15 Patient stories</div>
                </div>
            </div>


            <div className='w-1/3 lg:w-1/5 flex flex-col gap-y-2  place-content-center'>

                <CgProfile className='w-full h-[100px] sm:h-[150px] lg:h-[250px] place-self-center lg:hidden' />

                <div className='flex items-center gap-x-2 text-green-500'>
                    <MdCalendarMonth/>
                    <div>Available today </div>
                </div>

                <button className='px-4 py-2 w-fit bg-blue-400 text-white rounded-md hover:bg-blue-900 hover:scale-95  transition-all duration-1000'>
                    <div className='font-semibold '>Book Appointment</div>
                    <div className='text-sm'>No booking fee</div>
                </button>
            </div>
        </div>

        <div className='w-full h-[1px] bg-gray-300'></div>
    </div>
  )
}

export default Card2